/** The first tab stop on every route: bypass the header and land on the content. */
import React, { useCallback } from 'react';
import './SkipLink.css';

export default function SkipLink() {
    // This app routes on the hash (#/labs). A literal "#main" fragment would
    // overwrite the route, so focus is moved programmatically instead.
    const focusMain = useCallback((event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();
        const main = document.getElementById('main');
        if (!main) return;
        main.focus();
        // Not implemented in every environment; focus alone still lands correctly.
        main.scrollIntoView?.({ block: 'start' });
    }, []);

    return (
        <a className="skip-link" href="#main" onClick={focusMain}>Skip to content</a>
    );
}